// extracted by mini-css-extract-plugin
module.exports = {"cp-document-status__line":"styles_cp-document-status__line__2vg6A"};